<template>
  <div id="app" :style="safeArea">
    <div class="cs-servince-container" :style="containerStyle">
      <div class="app-navigator-header one-line"
           v-if="inApp && $route.meta.navigator && hiddenNavigation"
           :style="`height: ${42 + safeNum.sat}px;paddingTop: ${safeNum.sat}px`">{{pageTitle}}</div>
      <div v-if="inApp && hiddenNavigation"
           :class="['close iconfont icon_global_back_big', (inApp && $route.meta.navigator) ? 'black' : 'white']"
           :style="`top: ${safeNum.sat + 3}px`"
           @click="closeWindow"></div>
      <router-view/>
<!--      <div>-->
<!--        <button @click="getAppSystem">41</button>-->
<!--      </div>-->
    </div>
    <bindPhone v-model="bindPhoneStatus" :user-info="USERINFO"
               animateType="slideToTop"
               :mask="true"
               :bindType="PHONE_LOGIN_TYPE"
               :captchaApi="$rootApi"
               captchaKey="captcha"
               :smsApi="$rootApi"
               smsKey="getVerifyCode2"
               :bindApi="$rootApi"
               bindKey="bindMobilephone2"
               :loginApi="$rootApi"
               loginKey="phoneLogin"
               @bindSucc="bindSucc"
               @bindError="bindError"
               @loginSucc="loginSucc"></bindPhone>
  </div>
</template>

<script>
/* eslint-disable */
import bindPhone from '@spero/spero-utils/src/components/bind-phone'
import storeMixin from './mixins/store'
import queryString from '@spero/spero-utils/src/helpers/queryString'
import session from '@spero/spero-utils/src/helpers/session'
import storage from '@spero/spero-utils/src/helpers/storage'
import STORAGE from '@spero/spero-utils/src/constants/STORAGE'
import {compareVersion} from '@spero/spero-utils/src/helpers/utils'

require('@spero/spero-utils/src/constants/native-js-bridge')

let version = /YTX\/([\d.]+)/i.exec(navigator.userAgent) && RegExp.$1 || '0.0.0'

let STATE = []
let scrollTimer = null

export default {
  name: 'App',
  mixins: [storeMixin],
  components: {
    bindPhone
  },
  data () {
    return {
      hiddenNavigation: false,
      bindPhoneStatus: false,
      containerStyle: {}
    }
  },
  computed: {
    safeArea () {
      const {noTopSafe} = this.$route.meta
      let {sat, sar, sab, sal} = this.safeNum
      if (noTopSafe) {
        sat = 0
      }
      return {
        padding: `${sat}px ${sar}px ${sab}px ${sal}px`
      }
    }
  },
  watch: {
    PHONE_LOGIN_COUNT (val) {
      if (val) {
        if (!this.inApp) {
          // APP外登录
          this.bindPhoneStatus = true
        } else {
          // APP内登录
          this.appLogin()
        }
      }
    },
    '$route.name': {
      handler: function () {
        this.SET_PAGE_TITLE(this.$route.meta.title || document.title)
        let s = window.history.state ? window.history.state.key : ''
        let ti = STATE.findIndex(t => t === s)
        if (ti === -1) {
          STATE.push(s)
          ;(document.documentElement || document.body).scrollTo(0, 0)
        } else {
          STATE = STATE.splice(0, ti + 1)
        }
        this.scrollFn()
        this.SET_HAS_NAVIGATION(this.inApp && this.$route.meta.navigator && this.hiddenNavigation)
        this.init()
      }
    },
    loginCount (v) {
      console.log('loginCount', v)
      this.blLogin(this.USERINFO.userId)
    }
  },
  methods: {
    async init () {
      let {token, code} = queryString.query(location.search)
      // 第一次优先链接上的token
      token = token || session.get(STORAGE.LOGIN_TOKEN) || storage.get(STORAGE.LOGIN_TOKEN)
      const {noGlobalLogin} = this.$route.meta
      if (noGlobalLogin) {
        return
      }
      if (this.isWechat && !token && !code) {
        location.replace(this.authInWechat('cs-servince'))
        return
      }
      if (!token && code && code !== session.get('csServiceCode')) {
        await this.wechatLogin('csServiceCode', code)
      }
      // 第二次优先session里的token
      token = session.get(STORAGE.LOGIN_TOKEN) || token || storage.get(STORAGE.LOGIN_TOKEN)
      if (token) {
        this.getUserInfo(token)
      } else {
        this.anonymityLogin()
      }
    },
    tokenSet (token) {
      storage.set(STORAGE.LOGIN_TOKEN, token)
      session.set(STORAGE.LOGIN_TOKEN, token)
    },
    async wechatLogin (codeName, code) {
      try {
        // let {code} = queryString.query(location.search)
        let {data: {data: {token}}} = await this.$rootApi.api(['wxlogin'], {
          data: {
            code,
            distinctId: 'SPERO_APP_H5_DISTINCT_ID'
          }
        })
        session.set(codeName, code)
        this.tokenSet(token)
      } catch (err) {
        console.log('code换取token失败', err)
      }
    },
    async anonymityLogin () {
      const {data: {token}} = await this.$rootApi.login.anonymityLogin()
      this.tokenSet(token)
      this.getUserInfo(token)
    },
    async getUserInfo (token) {
      try {
        const {data: {code, data, message}} = await this.$rootApi.api(['pureUserInfo'])
        if (code === 0) {
          this.SET_USERINFO(data)
          this.SET_LOGIN_COUNT(token)
          if (!data.isTourist) {
            this.$sa.LOGIN(data.userId)
          }
        } else {
          throw message
        }
      } catch (e) {
        if (e && e.response && e.response.status === 401) {
          this.anonymityLogin()
        } else {
          // e && this.$toast(e.message || e)
        }
      }
    },
    blLogin (userId) {
      this.$__bl.setConfig({
        uid: userId
      })
    },
    bindSucc (phone) {
      this.SET_USERINFO(Object.assign(this.USERINFO, {phone}))
      this.SET_LOGIN_COUNT()
    },
    bindError (data, message) {
      if (data.status === 0) {
        this.bindPhoneStatus = false
        this.$layer2({
          type: 'confirm',
          content: `<p>该手机号已绑定</p><p>是否合并账号</p>`,
          onCancel: () => {
            this.$layer2({content: ''})
          },
          onOk: () => {
            let search = {
              token: session.get(STORAGE.LOGIN_TOKEN),
              redirectUrl: encodeURIComponent(queryString.addKey(location.href, {merge: 1})),
              mergeData: encodeURIComponent(JSON.stringify(data))
            }
            session.remove(STORAGE.LOGIN_TOKEN)
            location.href = origin + 'h5-template/' + queryString.objToStr(search) + '#/account-conflict'
          }
        })
      } else {
        this.$toast(message)
      }
    },
    async loginSucc (token) {
      this.$toast('登录成功')
      this.tokenSet(token)
      await this.getUserInfo(token)
      if (!this.USERINFO.phone) {
        this.SET_PHONE_LOGIN({type: 'bind'})
      }
    },
    appLogin () {
      const {event: {action}, action: {login}} = window.speroBridge
      if (window.YTXBridge) {
        window.YTXBridge.fireEvent(action, {
          actionType: login
        }, (cb) => {
          cb = JSON.parse(cb)
          this.tokenSet(cb.token)
          this.getUserInfo(cb.token)
        })
      } else {
        setTimeout(this.appLogin, 300)
      }
    },
    checkVal () {
      if (this.inApp) {
        this.setContainerHeight()
        const {event: {action}} = window.speroBridge
        if (window.YTXBridge) {
          window.YTXBridge.fireEvent(action, {
            actionType: '38'
          }, (cb) => {
            let s = getComputedStyle(document.documentElement)
            let sar = parseFloat(s.getPropertyValue('--sar'))
            let sab = parseFloat(s.getPropertyValue('--sab'))
            let sal = parseFloat(s.getPropertyValue('--sal'))
            let sat = JSON.parse(cb).statusBarHeight

            // this.safeArea = {
            //   padding: `${sat}px ${sar}px ${sab}px ${sal}px`
            // }
            this.SET_SAFE_NUM({sat, sab, sar, sal})
            this.setContainerHeight()
          })
        } else {
          setTimeout(this.checkVal, 100)
        }
      } else {
        this.setContainerHeight()
      }
      this.SET_HAS_NAVIGATION(this.inApp && this.$route.meta.navigator && this.hiddenNavigation)
    },
    setContainerHeight () {
      let h = (document.documentElement || document.body).clientHeight - this.safeNum.sat - this.safeNum.sab
      this.containerStyle = {minHeight: h + 'px'}
    },
    switchNav ()  {
      if (!window.YTXBridge) {
        setTimeout(() => {
          this.switchNav()
        }, 100)
        return
      }
      const {event: {action}} = window.speroBridge
      window.YTXBridge.fireEvent(action, {
        actionType: '40',
        data: {
          showNav: this.hiddenNavigation
        }
      })
      this.hiddenNavigation = !this.hiddenNavigation
      setTimeout(this.checkVal, 200)
    },
    getAppSystem () {
      const {event: {action}} = window.speroBridge
      window.YTXBridge && window.YTXBridge.fireEvent(action, {
        actionType: '41'
      }, (cb) => {
        console.log('getAppSystem---cb=', cb)
      })
    },
    closeWindow () {
      if (window.history.state) {
        window.history.back()
        return
      }
      const {
        action: {closeWindow},
        event: {action}
      } = window.speroBridge
      window.YTXBridge && window.YTXBridge.fireEvent(action, {
        actionType: closeWindow
      })
    },
    scrollFn () {
      let st = document.documentElement.scrollTop || document.body.scrollTop
      let ch = document.documentElement.clientHeight || document.body.clientHeight
      let sh = document.documentElement.scrollHeight || document.body.scrollHeight
      this.SET_SCROLL_VAL({
        SCROLL_TOP: st,
        SCROLL_TO_BOTTOM: sh - ch - st
      })
      clearTimeout(scrollTimer)
      this.SET_SCROLL_ING(true)
      scrollTimer = setTimeout(() => {
        this.SET_SCROLL_ING(false)
      }, 500)
    }
  },
  created () {
    let {hiddenNavigation} = queryString.query(location.search)
    hiddenNavigation = (hiddenNavigation && hiddenNavigation === 'true') || false
    this.hiddenNavigation = hiddenNavigation

    if (!hiddenNavigation && this.inApp && compareVersion(version, '7.27.0') > -1) {
      // APP环境，调用APP隐藏Nav
      this.switchNav()
    } else {
      this.checkVal()
    }
  },
  mounted () {
    // setTimeout(, 300)
    if (this.isWechat) {
      // Android微信中，借助WeixinJSBridge对象来阻止字体大小调整
      (function() {
        if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
          handleFontSize()
        } else {
          if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false)
          } else if (document.attachEvent) {
            //IE浏览器，非W3C规范
            document.attachEvent("onWeixinJSBridgeReady", handleFontSize)
          }
        }
        function handleFontSize() {
          // 设置网页字体为默认大小
          WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 })
          // 重写设置网页字体大小的事件
          WeixinJSBridge.on('menu:setfont', function() {
            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 })
          })
        }
      })()
    }

    window.onscroll = this.scrollFn
  }
}
</script>

<style lang="stylus" type="text/stylus">
@import "./assets/reset.styl"
#app
  min-height 100vh
  max-width 750px
  margin 0 auto
  background #fff
.cs-servince-container
  position relative
  background #fff
  .app-navigator-header
    position fixed
    width 100%
    left 0
    top 0
    padding 0 42px
    background #fff
    color #333
    font-size 17px
    text-align center
    line-height 42px
    font-weight bolder
    border-bottom 1px #E6E6E6 solid
    z-index 99999
    word-break break-all
  .close
    position fixed
    text-align center
    font-weight bolder
    z-index 99999
    &.white
      width 32px
      height @width
      left 15px
      line-height 32px
      background rgba(0, 0, 0, .4)
      color #fff
      border-radius 50%
      transition all .3s
    &.black
      width 36px
      height @width
      line-height 36px
      font-size 16px
      left 5px
      color #000
</style>
